var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlatmates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9621 14H14.3297C15.1921 14 15.878 13.6071 16.4939 13.0577C18.0585 11.6619 14.3806 10.25 13.125 10.25M11.625 2.80158C11.7953 2.7678 11.9722 2.75 12.1536 2.75C13.5185 2.75 14.625 3.75736 14.625 5C14.625 6.24264 13.5185 7.25 12.1536 7.25C11.9722 7.25 11.7953 7.2322 11.625 7.19842",
    stroke: "#253837",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.36098 11.0834C2.47675 11.5572 0.158353 12.5248 1.57041 13.7356C2.26019 14.327 3.02843 14.75 3.99429 14.75H9.50571C10.4716 14.75 11.2398 14.327 11.9296 13.7356C13.3416 12.5248 11.0232 11.5572 10.139 11.0834C8.06551 9.9722 5.43449 9.9722 3.36098 11.0834Z",
    stroke: "#253837",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 4.625C9.75 6.28185 8.40685 7.625 6.75 7.625C5.09315 7.625 3.75 6.28185 3.75 4.625C3.75 2.96815 5.09315 1.625 6.75 1.625C8.40685 1.625 9.75 2.96815 9.75 4.625Z",
    stroke: "#253837",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlatmates);
export default __webpack_public_path__ + "static/media/Flatmates.71f447c220cc8d66c2377dafc6ec39cb.svg";
export { ForwardRef as ReactComponent };